var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-style"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"item",class:{active: _vm.isActive(item)},on:{"click":function($event){return _vm.select(item)}}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-820f0278","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/subtitlePanel/fontStyle.vue
// module id = null
// module chunks = 